/** 403 when business has no Finmo beneficiary ID — user should add/configure payout beneficiary. */
export type ValidatePayoutBeneficiaryFailureKind = "missing_finmo_beneficiary" | "other";

export function parseValidatePayoutBeneficiaryHttpError(error: unknown): {
  userMessage: string;
  failureKind: ValidatePayoutBeneficiaryFailureKind;
} {
  const e = error as {
    status?: number;
    error?: { message?: string | string[]; errors?: { error?: { message?: string } } };
  };
  const finmoMsg = e?.error?.errors?.error?.message;
  const nest = e?.error?.message;
  const nestStr = Array.isArray(nest) ? nest.join(" ") : nest;
  const rawMessage =
    (typeof finmoMsg === "string" && finmoMsg.trim()) || (typeof nestStr === "string" && nestStr.trim()) || "";
  const status = e?.status ?? 0;
  const missingFinmo =
    status === 403 && rawMessage.toLowerCase().includes("does not have a finmo beneficiary");
  const failureKind: ValidatePayoutBeneficiaryFailureKind = missingFinmo ? "missing_finmo_beneficiary" : "other";

  let userMessage = rawMessage;
  if (!userMessage) {
    if (status === 0) {
      userMessage = "Network error. Please try again.";
    } else if (status >= 500) {
      userMessage = "Our payments partner is temporarily unavailable. Please try again later.";
    } else {
      userMessage = "Something went wrong. Please try again.";
    }
  }
  return { userMessage, failureKind };
}
